// extracted by mini-css-extract-plugin
export const page_header = "PageHeader-module--page_header--1ipjx";
export const page_header__thumbnail = "PageHeader-module--page_header__thumbnail--25MYT";
export const page_header__title = "PageHeader-module--page_header__title--2ibcl";
export const page_header__image = "PageHeader-module--page_header__image--3njDS";